export enum BackgroundColorSchemes {
  PrimaryDefaultLight = 'Primary Default - Light',
  PrimaryDefaultDark = 'Primary Default - Dark',
  SecondaryDefaultLight = 'Secondary Default - Light',
  SecondaryDefaultDark = 'Secondary Default - Dark',
  SecondaryDarkLight = 'Secondary Dark - Light',
  SecondaryDarkDark = 'Secondary Dark - Dark',
  AccentDefaultLight = 'Accent Default - Light',
  AccentDefaultDark = 'Accent Default - Dark',
  TertiaryDefaultLight = 'Tertiary Default - Light',
  TertiaryDefaultDark = 'Tertiary Default - Dark',
}

export type Background = {
  name?: BackgroundColorSchemes
  value?: string
}
